import { render } from "./LeaderCard.vue?vue&type=template&id=25706b85&scoped=true"
import script from "./LeaderCard.vue?vue&type=script&lang=js"
export * from "./LeaderCard.vue?vue&type=script&lang=js"

import "./LeaderCard.vue?vue&type=style&index=0&id=25706b85&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25706b85"]])

export default __exports__